import React, { useEffect, useState } from "react";
import Switch from "react-switch";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import productAction from "../stores/actions/ProductAction";

const StatusSwitch = ({ productId, statusActive }: any) => {
  const dispatch = useDispatch<any>();
  const [statusVal, setStatusVal] = useState<boolean>(false);
  const [isLoader, setIsLoader] = useState<boolean>(false);

  useEffect(() => {
    setStatusVal(statusActive === "ACTIVATE");
  }, []);

  const handleStatus = async () => {
    setIsLoader(true);
    try {
      await dispatch(
        productAction.changeStatus({
          id: productId,
          status: statusActive === "ACTIVATE" ? "DEACTIVATE" : "ACTIVATE",
        }),
      );
      setIsLoader(false);
      setStatusVal(!statusVal);
      statusActive === "ACTIVATE"
        ? toast.error(`PRODUCT DEACTIVATE SUCCESSFULLY`)
        : toast.success(`PRODUCT ACTIVATE SUCCESSFULLY`);
    } catch (e: any) {
      setIsLoader(false);
      toast.error(e.message);
    }
  };

  return isLoader ? (
    <i className={"fa fa-spinner fa-spin"}></i>
  ) : (
    <Switch
      onChange={handleStatus}
      checked={statusVal}
      checkedIcon={false}
      uncheckedIcon={false}
      offColor={"#ff0000"}
    />
  );
};

export default StatusSwitch;
